import { VehicleNotificationType } from './notifications-types';

export const getNotificationTag = (notificationType: VehicleNotificationType) => {
	switch (notificationType) {
		case VehicleNotificationType.PreITV:
			return `ITV`;
		case VehicleNotificationType.Mantenimiento:
			return `Mantenimiento`;
		default:
			return '';
	}
};

export const getNotificationMessage = (notificationType: VehicleNotificationType, comercialDenomination: string) => {
	const vehicleName = comercialDenomination || 'Volkswagen';
	switch (notificationType) {
		case VehicleNotificationType.PreITV:
			return `Tu ${vehicleName} tiene una cita: la ITV`;
		case VehicleNotificationType.Mantenimiento:
			return `Recuerda que tu ${vehicleName} tiene que pasar por taller `;
		default:
			return '';
	}
};
